import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getReminderSendReport } from "../../../services/ReportService";
import { formatDateToApi } from "../../../utils/dateUtils";

const RemindersSentModal = ({ show, onHide, startDate, endDate }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show, startDate, endDate]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const fromDate = formatDateToApi(startDate);
      const toDate = formatDateToApi(endDate);
      const res = await getReminderSendReport(
        0,
        10,
        "",
        fromDate,
        toDate
      );
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview reminders sent data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/player-Reminder-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-bell text-warning me-2"></i>
          Reminders Sent - Recent History
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="warning" />
            <p className="mt-2 text-muted">Loading reminder records...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Player Id</th>
                  <th>Player Name</th>
                  <th>Mobile</th>
                  <th>Package</th>
                  <th>Reminder Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item?.player?.serialNumber || item?.serialNumber || "-"}</td>
                      <td className="fw-semibold">
                        {item?.player?.name || item?.name || "-"}
                      </td>
                      <td>{item?.player?.phone || item?.phone || "-"}</td>
                      <td>
                        {item?.subscription?.packageType?.name ||
                          item?.player?.subscription?.packageType?.name ||
                          item?.playerSubscription?.packageType?.name ||
                          item?.player?.playerSubscription?.packageType?.name ||
                          item?.package?.packageType?.name ||
                          item?.packageType?.name ||
                          item?.player?.subscription?.name ||
                          item?.package?.name ||
                          "-"}
                      </td>
                      <td className="fw-semibold text-warning">
                        {item?.reminderDate || item?.createdDate || item?.date || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center py-4 text-muted">
                      No reminder records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemindersSentModal;

